import React from 'react';
import { Route, Switch } from 'react-router';
import { technologyMenuRoutes } from '../constants';



export const TechnologyMenuRoutes = () => {

  return (
		<Switch>
			{
				[technologyMenuRoutes.map((route, index) => {
					return (
						<Route 
							key={index}
							path={route.path}
							exact={route.exact}
							render={() => <route.component />} />													
					)
					})					
				]
			}
		</Switch>
	);
}
